import axios from "axios";
import {useQuery} from "@tanstack/vue-query";

const getBacklinkOpportunities = (activeTab, activeCompetitor) =>  useQuery({
  queryKey: ['backlink-opportunity', activeTab, activeCompetitor],
  queryFn: async () => {
    const query = new URLSearchParams();

    let status;
    switch (activeTab.value) {
      case 'in-progress':
        status = 'contacted';
        break;
      case 'removed':
        status = 'removed';
        break;
      case 'completed':
        status = 'completed';
        break;
      default:
        status = 'pending';
    }

    query.append('status', status);
    if (activeCompetitor.value) {
      query.append('competitor', activeCompetitor.value);
    }

    const { data } = await axios.get(`/ajax/v2/backlinks/opportunity?` + query.toString());

    return data.data;
  },
});

export {
  getBacklinkOpportunities,
}
